import { Image } from "@chakra-ui/react";
import IconBackgound from "src/atoms/IconBackground";
import SvgContainer from "./SvgContainer";

export default function IconOnBackgound({
  src,
  bg,
  icon,
  fill,
  iconSize,
  ...rest
}) {
  return src ? (
    <IconBackgound bg={bg} {...rest}>
      <Image src={src} />
    </IconBackgound>
  ) : (
    <IconBackgound bg={bg} {...rest}>
      <SvgContainer icon={icon} fill={fill} size={iconSize} />
    </IconBackgound>
  );
}
